export default __webpack_public_path__ + "static/media/DSS_Banner_1440x300.56fd9454.jpg";